import { View, StyleSheet } from "react-native";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomText from "../../common/general/CustomText/CustomText";
import { ExitDoor } from "../../svgs/common";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import { ASSESSMENT_MENU_HEIGHT } from "../../../constants/assessmentConstants";
import CompactMicrophoneSelector from "../../../containers/assessment/sharedFiles/CompactMicrophoneSelector";

function AssessmentMenu({
  handleExitPress,
  remainingTime,
  moduleName,
  hasMicrophoneControls,
  timeIsLoading,
  isSseAssessment,
  selectedDeviceId,
  onDeviceSelect,
}) {
  const { isMedium } = useResponsiveScreen();

  return (
    <View
      style={[styles.container, isMedium ? styles.desktop : styles.mobile]}
      aria-live="polite"
      aria-label="Assessment Menu"
      role="menu">
      <View
        style={[
          styles.leftContainer,
          {
            width: hasMicrophoneControls && isMedium ? "40%" : "100%",
            maxWidth: hasMicrophoneControls && isMedium ? "40%" : "100%",
          },
        ]}>
        <View style={styles.exitButtonContainer}>
          <CustomButton leftIcon={<ExitDoor />} onPress={handleExitPress} size="s" styleType="transparent" />
        </View>
        {isMedium && (
          <>
            <View style={styles.verticalDivider} />
            <CustomSpacing type="horizontal" size="xl" />
          </>
        )}
        <CustomText
          text="assessment_menu_title"
          role="header"
          aria-level="3"
          size="m"
          numberOfLines={1}
          ellipsizeMode="tail"
          weight="bold"
          textType="text"
          interpolation={{ moduleName }}
          style={{ flex: 1, width: "100%" }}
        />
      </View>
      {hasMicrophoneControls && (
        <View style={isMedium ? styles.voiceAssistantContainer : styles.mobileVoiceAssistantContainer}>
          <CompactMicrophoneSelector selectedDeviceId={selectedDeviceId} onDeviceSelect={onDeviceSelect} />
        </View>
      )}
      <View
        style={
          isMedium
            ? [
                styles.timerWrapper,
                {
                  width: hasMicrophoneControls ? "40%" : "63px",
                  maxWidth: hasMicrophoneControls ? "40%" : "63px",
                  minWidth: "90px",
                },
              ]
            : styles.mobileTimerWrapper
        }>
        <View style={[styles.timerContainer, { marginRight: isMedium ? 20 : 0 }]}>
          <CustomText
            text={timeIsLoading ? "--:--" : remainingTime}
            useTranslationText={false}
            accessibilityHint="Remaining time for the assessment"
            size="s"
            weight="ultraBold"
            style={{ color: "#475467" }}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    top: 0,
    left: 0,
    bottom: 0,
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    zIndex: 20,
    elevation: 5,
    height: ASSESSMENT_MENU_HEIGHT,
    maxHeight: ASSESSMENT_MENU_HEIGHT,
    borderBottomWidth: 1,
    borderBottomColor: "#EAECF0",
  },
  desktop: {
    flexDirection: "row",
    height: ASSESSMENT_MENU_HEIGHT,
    maxHeight: ASSESSMENT_MENU_HEIGHT,
    gap: 20,
  },
  mobile: {
    flexDirection: "column",
    height: "auto",
    maxHeight: "auto",
    paddingRight: 0,
    gap: 0,
    paddingBottom: 10,
    paddingTop: 10,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    flex: 1,
  },
  exitButtonContainer: {
    display: "flex",
    flexDirection: "row",
    paddingHorizontal: 12,
    flex: 1,
    width: 64,
    maxWidth: 64,
  },
  timerContainer: {
    backgroundColor: "#EAECF0",
    paddingHorizontal: 12,
    paddingVertical: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    width: "63px",
    maxWidth: "63px",
    flex: 1,
  },
  verticalDivider: {
    width: 1,
    height: 52,
    backgroundColor: "#EAECF0",
  },
  voiceAssistantContainer: {
    flex: 1,
    maxWidth: "10%",
    width: "10%",
    justifyContent: "center",
    alignItems: "center",
  },
  timerWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  mobileVoiceAssistantContainer: {
    flex: 1,
    maxWidth: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  mobileTimerWrapper: {
    flex: 1,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    height: 36,
    minHeight: 36,
  },
});

export default AssessmentMenu;
